import { Component, Inject, TemplateRef } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'navigation-blocker-dialog',
    templateUrl: 'navigation-blocker-dialog.component.html',
    styleUrls: ['navigation-blocker-dialog.component.less'],
    standalone: false
})
export class NavigationBlockerDialogComponent {
    constructor(
        public dialogRef: DialogRef<NavigationBlockerDialogComponent>,
        @Inject(DIALOG_DATA)
        public data: {
            template: TemplateRef<any>;
        }
    ) {}
}
